import { render } from "./HelpMobile.vue?vue&type=template&id=5edbd8be&scoped=true"
import script from "./HelpMobile.vue?vue&type=script&lang=js"
export * from "./HelpMobile.vue?vue&type=script&lang=js"

import "./HelpMobile.vue?vue&type=style&index=0&id=5edbd8be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5edbd8be"]])

export default __exports__